import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { queryClient } from '../../../App'
import { getMaintenanceReports } from '../../../services/NewApiService'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'
import { ParamsType } from '../types/maintenance-reports.types'

const initParams: ParamsType = {}

export const maintenanceReportsPaginationStore = new NewPaginationStore(
  initParams,
)

export const useGetServiceReportTableData = () => {
  const {
    page,
    size,
    sort,
    params: {
      IsDealerSenderOnly,
      closeDateFrom,
      closeDateTo,
      creationDateFrom,
      creationDateTo,
      reportId,
      statuses,
      dealerIds,
    },
    setPage,
  } = maintenanceReportsPaginationStore

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        'service-reports-table',
        size,
        page,
        sort,
        IsDealerSenderOnly,
        closeDateFrom,
        closeDateTo,
        creationDateFrom,
        creationDateTo,
        reportId,
        statuses,
        userId,
        dealerIds,
      ],
      queryFn: () =>
        getMaintenanceReports({
          size,
          page,
          IsDealerSenderOnly,
          closeDateFrom,
          closeDateTo,
          creationDateFrom,
          creationDateTo,
          reportId,
          statuses,
          dealerIds,
          sort: sort ?? undefined,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId,
    },
    queryClient,
  )
}
